import { AuditColumnModel } from "src/app/model";

export interface PlantPocModel extends Pick<AuditColumnModel, "_id"> {
  name: string;
  email: string;
  phone: {
    country: string;
    countryCode: number;
    number: number;
  }
}

export interface PlantModel extends Pick<AuditColumnModel, "_id"> {
  name: string;
  about: string;
  email: string;
  image: string;
  thumbnail: string;
  phone: {
    country: string;
    countryCode: number;
    number: number;
  },
  startDate: string;
  endDate: string;
  poc: PlantPocModel[],
  status: boolean;
}